import { NgModule } from '@angular/core';
import { CmsComponent } from './cms.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../common/auth.guard';
import { PermissionGuard } from '../common/permission.guard';

const routes: Routes = [
  {
    path: '',
    component: CmsComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/default/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'document',
        loadChildren: () =>
          import('./pages/default/document/document.module').then(
            (m) => m.DocumentModule
          ),
      },
      {
        path: 'employee',
        loadChildren: () =>
          import('./pages/default/employee/employee.module').then(
            (m) => m.EmployeeModule
          ),
      },
      {
        path: 'project',
        loadChildren: () =>
          import('./pages/default/project/project.module').then(
            (m) => m.ProjectModule
          ),
      },
      {
        path: 'partner',
        loadChildren: () =>
          import('./pages/default/partner/partner.module').then(
            (m) => m.PartnerModule
          ),
      },
      {
        path: 'resource',
        loadChildren: () =>
          import('./pages/default/resource/resource.module').then(
            (m) => m.ResourceModule
          ),
      },
      {
        path: 'safety-equipment',
        loadChildren: () =>
          import(
            './pages/default/safety-equipment/safety-equipment.module'
          ).then((m) => m.SafetyEquipmentModule),
      },
      {
        path: 'time-management',
        loadChildren: () =>
          import('./pages/default/time-management/time-management.module').then(
            (m) => m.TimeManagementModule
          ),
      },
      {
        path: 'equipment',
        loadChildren: () =>
          import('./pages/default/equipment/equipment.module').then(
            (m) => m.EquipmentModule
          ),
      },
      {
        path: 'finance',
        loadChildren: () =>
          import('./pages/default/finance/finance.module').then(
            (m) => m.FinanceModule
          ),
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./pages/default/report/report.module').then(
            (m) => m.ReportModule
          ),
          data :{ permissions : ['READ_REPORTING_PRODUCTION'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/production-cu',
        loadChildren: () =>
          import('./pages/default/production-cu/production-cu.module').then(
            (m) => m.ReportProductionCuModule
          ),
          data :{ permissions : ['READ_REPORTING_PRODUCTION'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/performance',
        loadChildren: () =>
          import('./pages/default/report-performance/report-performance.module').then(
            (m) => m.ReportPerformanceModule
          ),
          data :{ permissions : ['READ_REPORTING_PERFORMANCE'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/qs',
        loadChildren: () =>
          import('./pages/default/report-qs/report-qs.module').then(
            (m) => m.ReportQsModule
          ),
          data :{ permissions : ['READ_REPORTING_QC'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/quality-control',
        loadChildren: () =>
          import('./pages/default/report-quality-control-syncfusion/report-quality-control.module').then(
            (m) => m.ReportQualityControlModule
          ),
          data :{ permissions : ['READ_QUALITY_CONTROL'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/termine',
        loadChildren: () =>
          import('./pages/default/report-termine/report-termine.module').then(
            (m) => m.ReportTermineModule
          ),
          data :{ permissions : ['READ_REPORTING_TERMINE'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/deviations',
        loadChildren: () =>
          import('./pages/default/report-deviations/report-deviations.module').then(
            (m) => m.ReportDeviationModule
          ),
          data :{ permissions : ['READ_REPORTING_DEVIATION'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/work-packages',
        loadChildren: () =>
          import('./pages/default/report-work-packages/report-work-packages.module').then(
            (m) => m.ReportWorkPackagesModule 
          ),
          data :{ permissions : ['READ_REPORTING_DEVIATION'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/planning',
        loadChildren: () =>
          import('./pages/default/report-planning/report-planning.module').then(
            (m) => m.ReportPlanningModule
          ),
          data :{ permissions : ['READ_REPORTING_DEVIATION'] },
          'canActivate':[PermissionGuard]
      },
      {
        path: 'report/sga',
        loadChildren: () =>
          import('./pages/default/report-absence/report-absence.module').then(
            (m) => m.ReportAbsenceModule
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./pages/default/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: 'ticket',
        loadChildren: () =>
          import('./pages/default/ticket/ticket.module').then(
            (m) => m.TicketModule
          ),
      },
      {
        path: 'permission',
        loadChildren: () =>
          import('./pages/default/permission/permission.module').then(
            (m) => m.PermissionModule
          ),
      },
      {
        path: 'versioning',
        loadChildren: () =>
          import('./pages/default/versioning/versioning.module').then(
            (m) => m.VersioningModule
          ),
      },
      {
        path: 'libraries',
        loadChildren: () =>
          import('./pages/default/knowledge/knowledge.module').then(
            (m) => m.KnowledgeModule
          ),
      },
      {
        path: 'chat',
        loadChildren: () =>
          import('./pages/default/chat/chat.module').then(
            (m) => m.ChatModule
          ),
      },
      {
        path: 'audit',
          loadChildren: () =>
            import('./pages/default/audit/audit.module').then(
              (m) => m.AuditModule
            ),
            data :{ permissions : ['READ_AUDITS'] },
            'canActivate':[PermissionGuard]
      },
      {
        path: 'e-learning',
        loadChildren: () => import('./pages/default/e-learning/e-learning.module').then((m) => m.ELearningModule),
      },  
      {
        path: 'test',
        loadChildren: () => import('./pages/default/test/test.module').then((m) => m.TestModule),
      },  
      //   {
      //     path: '',
      //     redirectTo: 'index',
      //     pathMatch: 'full',
      //   },
    ],
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CmsRoutingModule {}
